import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectBoardUserAcquired, selectBoardUserAcquiring } from "src/app/store/device/device.selector";
import * as DeviceActions from 'src/app/store/device/device.actions';

@Component({
	templateUrl: './acquire-board-user.dialog.component.html',
})

export class AcquireBoardUserDialogComponent implements OnInit, OnDestroy {
   boardUserAcquiring : boolean;
   boardUserAcquiring$ : Observable<boolean | undefined>;
   boardUserAcquiringSub : Subscription

   boardUserAcquired : boolean;
   boardUserAcquired$ : Observable<boolean | undefined>;
   boardUserAcquiredSub : Subscription;

   loadingValue = 20;

   interval: any;

   // design
   screenWidth: number;
   MIN_MD_WIDTH = 500;
   MAX_MD_WIDTH = 1120;
   MIN_WIDTH_COL4 = 1680;
   DELTA_ERROR_PIXEL = 7;
   MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

   constructor(
      private store: Store<AppState>,
      private ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
   ) {
      this.initSelectors();
   }

   initSelectors(): void {
      this.boardUserAcquiring$ = this.store.select(selectBoardUserAcquiring);
      this.boardUserAcquired$ = this.store.select(selectBoardUserAcquired);
   }

   ngOnInit(): void {
      this.subscribeAll();
      this.startAcquisition();
   }

   ngOnDestroy(): void {
      this.boardUserAcquiringSub?.unsubscribe();
      this.boardUserAcquiredSub?.unsubscribe();
   }

   subscribeAll(): void { 
      this.boardUserAcquiringSub = this.boardUserAcquiring$
         .subscribe((aquiring) => { 
            this.boardUserAcquiring = aquiring;
         }
      );
      this.boardUserAcquiredSub = this.boardUserAcquired$
         .pipe(filter(d => !!d))
         .subscribe(() => { 
            this.ref.close();
         }
      );
   }

   startAcquisition(): void {
      this.loadingValue = 20;
      setTimeout(() => { // stops loading after 22secs
         clearInterval(this.interval);
         this.ref.close();
      }, 22000);
      this.interval = setInterval(() => { // spinner loader grows at every 220ms
         this.loadingValue -= 1;
      }, 1000);
      this.store.dispatch(DeviceActions.acquireBoardUser());
   }

   closeDialog(): void {
      this.ref.close();
   }

   // Design
   @HostListener('window:resize', ['$event'])
   onResize() {
      this.screenWidth = window.innerWidth;
   }

   onMobile(): boolean {
      return this.screenWidth <= this.MIN_MD_WIDTH;
   }

   dynamicButtonWidth(): string {
      return this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH
            ? 'w-full'
            : 'w-16rem';
   }
}